<h1 mat-dialog-title>
	{{ !this.data.resourceToEdit ? 'Crear' : 'Editar' }} recurso
</h1>
<div mat-dialog-content class="new-resource-form">
	<form autocomplete="off" [formGroup]="resourceForm">
		<div class="clearfix">
			<div class="col col-6 px2 resource_name">
				<mat-form-field appearance="fill">
					<mat-label>Nombre del recurso</mat-label>
					<input matInput formControlName="name" />
				</mat-form-field>
			</div>
			<div class="col col-6 px2">
				<mat-form-field appearance="fill">
					<mat-label>Descripción del recurso</mat-label>
					<input matInput formControlName="description" />
				</mat-form-field>
			</div>
		</div>
		<div class="clearfix">
			<div class="col col-6 px2">
				<mat-form-field appearance="fill">
					<mat-label>Categoría del recurso</mat-label>
					<mat-select formControlName="category">
						<mat-option *ngFor="let item of categoriesList" [value]="item.id">
							{{ item.name }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</form>
</div>
<div mat-dialog-actions>
	<button mat-raised-button color="danger" mat-dialog-close>
		<mat-icon class="mr1">logout</mat-icon>
		<span>Cancelar</span>
	</button>
	<button
		mat-raised-button
		color="primary"
		(click)="saveResource()"
		[disabled]="!resourceForm.valid"
	>
		<mat-icon class="mr1">save</mat-icon>
		<span>Guardar</span>
	</button>
</div>
